const phoneNumberScript = function () {
    var phoneProfileDefault = $('#default-edit-phone-tel-order').val();
    // =============================== Trinh handle phone number =====================================
    var inputPhoneTel = document.querySelector("#edit-phone-tel-order");
    var intlPhoneTelInput = window.intlTelInput(inputPhoneTel, {
        formatOnDisplay: false, separateDialCode: true,
    });
    $('#btn-edit-phone').prop('disabled', false);
    if(phoneProfileDefault) { intlPhoneTelInput.setNumber(`+`+ phoneProfileDefault);  }
    const inputPhoneTelChange = function() {
        const value = inputPhoneTel.value.trim();
        if (inputPhoneTel.value.trim()) {
            if (intlPhoneTelInput.isValidNumber() && phoneProfileDefault != value) {
                inputPhoneTel.classList.remove("error");
                $('#btn-edit-phone').prop('disabled', false);
            } else {
                inputPhoneTel.classList.add("error");
                $('#btn-edit-phone').prop('disabled', true);
            }
        }

    }
    inputPhoneTel.addEventListener('keyup', inputPhoneTelChange);
    inputPhoneTel.addEventListener("countrychange", function() {
        $('#btn-edit-phone').prop('disabled', true);
    });
}

function submitAndVerifyPhoneNumber(phone, opts = {}) {
  const successCallback = opts.successCallback || function() {};
  const submitUrl = opts.submitUrl == undefined && true || opts.submitUrl;
  const savePhoneUrl =  opts.savePhoneUrl || '/users/save/phone';

  const digitsPerBox = 1;
  $(document).on('input','.inputNumber', function(e) {
    if (e.target.value.length == digitsPerBox) {
      var t = $( e.target );
      if (t.attr("id") !== "inputNumber4") {
          t.next().focus();
      }
    }
    if (e.target.value.length > digitsPerBox) {
      e.target.value = e.target.value.substr(0,digitsPerBox);
    }
  });

  $(document).on('click', '.send-new-code', function(){
      $.ajax({
          url: '/users/submit/phone',
          method: 'POST',
          dataType: 'json',
          contentType: "application/json; charset=utf-8",
          data: JSON.stringify({ phone: phone, valPhone: true, runVerify: true }),
          success: function (data) {
              toastr.success(`New code sent`);
          },
          error: function (error) {
              toastr.error(data.message || `Save phone failed`);
          }
      })
  })

  $.ajax({
    url: '/users/submit/phone',
    method: 'POST',
    dataType: 'json',
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify({ phone: phone, valPhone: true, runVerify: true }),
    success: function (data) {
        if (data && data.success && data.phone) {
            const phoneFormat = data.phone;
            Swal.fire({
                  title: "Confirm Code",
                  html: `
                    <div style="display: flex; flex-direction: column; align-items: center;" class="formInputNumber">
                      <p>Please enter the 4-digit code we sent you via text:</p>
                      <div style="display: flex; gap: 5px;">
                        <input id="inputNumber1" class="inputNumber" type="text" maxlength="1" style="width: 30px; text-align: center;">
                        <input id="inputNumber2" class="inputNumber" type="text" maxlength="1" style="width: 30px; text-align: center;">
                        <input id="inputNumber3" class="inputNumber" type="text" maxlength="1" style="width: 30px; text-align: center;">
                        <input id="inputNumber4" class="inputNumber" type="text" maxlength="1" style="width: 30px; text-align: center;">
                      </div>
                      <div id="errorMessage" style="color: red; margin-top: 10px;"></div>
                      <div style="margin-top: 15px;">
                        <button id="btn-submit-code" style="background-color: #02843d; color: white; padding: 8px 15px; border: none; cursor: pointer;">
                          Submit
                        </button>
                      </div>
                      <div style="margin-top: 10px;">
                        <p>Didn't receive the code? <a href="javascript:void(0)" id="resendCode" style="color: #02843d;">Resend</a></p>
                      </div>
                    </div>
                  `,
                  showConfirmButton: false, // ✅ Hide default Swal button
                  allowOutsideClick: false,
                });

                // ✅ Attach event listener after popup is rendered
                setTimeout(() => {
                  document.getElementById("btn-submit-code").addEventListener("click", () => {
                    let inputValue = 
                      document.getElementById("inputNumber1").value +
                      document.getElementById("inputNumber2").value +
                      document.getElementById("inputNumber3").value +
                      document.getElementById("inputNumber4").value;

                    if (!inputValue || inputValue.length < 4) {
                      document.getElementById("errorMessage").innerText = "Please enter all 4 digits.";
                      return;
                    }

                    $.ajax({
                      url: savePhoneUrl,
                      method: 'POST',
                      dataType: 'json',
                      contentType: "application/json; charset=utf-8",
                      data: JSON.stringify({ phone: phoneFormat, code: inputValue }),
                      success: function (data) {
                        if (data && data.success) {
                          Swal.fire({
                            icon: 'success',
                            title: 'Verified Successfully!',
                          });
                        } else {
                          document.getElementById("errorMessage").innerHTML = `
                            <p>Sorry, that code is incorrect. Try again or <a href="javascript:void(0)" id="resendCode" style="color: #02843d;">request a new code</a>.</p>
                          `;
                        }
                      },
                      error: function (error) {
                        Swal.fire({
                          icon: 'error',
                          title: 'Oops',
                          text: 'Verification failed, please try again later.',
                        });
                      }
                    });
                  });

                  // ✅ Handle Resend Code
                  document.getElementById("resendCode").addEventListener("click", () => {
                    console.log("Resend code clicked");
                    // Add resend logic here...
                      $.ajax({
                          url: '/users/submit/phone',
                          method: 'POST',
                          dataType: 'json',
                          contentType: "application/json; charset=utf-8",
                          data: JSON.stringify({ phone: phone, valPhone: true, runVerify: true }),
                          success: function (data) {
                              toastr.success(`New code sent`);
                          },
                          error: function (error) {
                              toastr.error(data.message || `Save phone failed`);
                          }
                      })
                  });

                }, 100);

        } else {
            Swal.fire("Error!", data.message || 'Save phone failed', "error");
        }
    },
    error: function (error) {
        toastr.error(data.message || `Save phone failed`);
    },
    complete: function () {
    }
  })
}
window.submitAndVerifyPhoneNumber = submitAndVerifyPhoneNumber;
